import { ICustomIconProps } from './types';

const IconTabChart: React.FC<ICustomIconProps> = ({ size = 16, className }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path
      d='M14.6666 14.6665H1.33331C1.05998 14.6665 0.833313 14.4398 0.833313 14.1665C0.833313 13.8932 1.05998 13.6665 1.33331 13.6665H14.6666C14.94 13.6665 15.1666 13.8932 15.1666 14.1665C15.1666 14.4398 14.94 14.6665 14.6666 14.6665Z'
      fill='currentColor'
    />
    <path d='M6.5 2.66683V14.6668H9.5V2.66683C9.5 1.9335 9.2 1.3335 8.3 1.3335H7.7C6.8 1.3335 6.5 1.9335 6.5 2.66683Z' fill='currentColor' />
    <path d='M2 6.66683V14.6668H4.66667V6.66683C4.66667 5.9335 4.4 5.3335 3.6 5.3335H3.06667C2.26667 5.3335 2 5.9335 2 6.66683Z' fill='currentColor' />
    <path
      d='M11.3333 9.99984V14.6665H14V9.99984C14 9.2665 13.7333 8.6665 12.9333 8.6665H12.4C11.6 8.6665 11.3333 9.2665 11.3333 9.99984Z'
      fill='currentColor'
    />
  </svg>
);

export default IconTabChart;
